import {
  ListLessonPlanItemFilters,
  listLessonPlanItems,
} from '@/data/services/lessonPlanItemServices';

export const lessonPlanItemQueries = {
  all: ['lessonPlanItems'] as const,

  list: (filters: ListLessonPlanItemFilters = {}) => ({
    queryKey: [...lessonPlanItemQueries.all, 'list', filters] as const,
    queryFn: () => listLessonPlanItems(filters),
  }),
};
